var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-families-new-view"
  }, [(_vm.isBundle) ? _c('h1', [_vm._v(_vm._s(_vm.$t('titles.newBundle')))]) : _c('h1', [_vm._v(_vm._s(_vm.$t('titles.newStandard')))]), _vm._v(" "), (_vm.isBundle) ? _c('bundle-product-family-form', {
    attrs: {
      "disabled": _vm.isSubmitting,
      "errors": _vm.errors
    },
    on: {
      "submit": _vm.insertBundleProductFamily
    }
  }) : _c('standard-product-family-form', {
    attrs: {
      "disabled": _vm.isSubmitting,
      "errors": _vm.errors
    },
    on: {
      "submit": _vm.insertStandardProductFamily
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c91932f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/ProductFamilies/NewView.vue
// module id = 2106
// module chunks = 0